import Cookies from 'universal-cookie';

export const universalCookies = new Cookies();
